import { CDBTable, CDBTableBody, CDBTableHeader, CDBSpinner } from "cdbreact";
import { trim } from "../../utils/trim"
import styles from "../Table/Table.module.css";
import TrimmedText from '../../utils/TrimmedText';

const TableCustom = ({ headers, loading, data, setPressedButton }) => {

  if (loading) {
    return (
      <div className="d-flex m-4 justify-content-center align-items-center">
        <CDBSpinner multicolor />
      </div>
    );
  } else if (data.length === 0) {
    return (
      <div className={styles.noData}>
        <h1>Ningún elemento encontrado</h1>
        <p className={styles.noDataDesc}>Intenta refrescar</p>
      </div>
    );
  } else {
    return (
      <CDBTable responsive hover stripped>
        <CDBTableHeader>
          <tr className={styles.theadDark}>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </CDBTableHeader>
        <CDBTableBody>
          {data.map((row, index) => {
            return (<tr
              key={"tr-" + index}
              onClick={() => {
                setPressedButton(`edit,${row[1]},${row[2]}`);
              }}
            >
              {row.map((cell, index) => (
                <td key={"td-" + index}><TrimmedText text={String(cell)} size={50} /></td>
              ))}
            </tr>);
          }
          )}
        </CDBTableBody>
      </CDBTable>
    );
  }
};

export default TableCustom;
